// extracted by mini-css-extract-plugin
export default {"container":"InvalidLink_container__RGSqq","logo":"InvalidLink_logo__djmxl","greet":"InvalidLink_greet__9-t6A","title":"InvalidLink_title__zwPJ2","info":"InvalidLink_info__CKzE+"};